import { Phone } from "lucide-react";
import { BUSINESS } from "../data/content";
import { Reveal } from "./Reveal";
import { Section } from "./Section";

export const Reservation = ({ onReserve }) => (
  <Section id="reserve" className="!max-w-none !px-0">
    <div className="relative overflow-hidden border-y border-[rgba(247,244,239,0.1)] bg-[#1a1613]">
      <div
        className="pointer-events-none absolute -left-24 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-[#8a3b14]/25 blur-3xl"
        aria-hidden="true"
      />
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 sm:px-8 md:py-28 lg:grid-cols-2">
        <Reveal>
          <p className="eyebrow mb-4">Reservations</p>
          <h2 className="font-display text-4xl font-semibold leading-[1.08] tracking-tight text-[#f7f4ef] sm:text-5xl">
            Save your corner of the room
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-[#b5afa7] md:text-lg">
            Tell us when you'd like to come by, or simply give us a call — the fastest way to a
            table at Roma's is a two-minute conversation.
          </p>
          <p className="mt-4 text-xs italic text-[#8f887f]" data-testid="reservation-demo-note">
            The enquiry form on this demo website does not send or book anything — tables are
            confirmed by phone.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="card-surface p-8 md:p-10">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#8f887f]">
              Call to reserve
            </p>
            <div className="mt-4 space-y-3">
              {BUSINESS.phones.map((p) => (
                <a
                  key={p.href}
                  href={p.href}
                  data-testid={`reservation-phone-${p.href.replace(/[^0-9]/g, "")}`}
                  className="font-display flex items-center gap-3 text-2xl font-semibold text-[#f7f4ef] transition-colors hover:text-[#d4af37] md:text-3xl"
                >
                  <Phone size={22} className="text-[#d4af37]" aria-hidden="true" />
                  {p.label}
                </a>
              ))}
            </div>
            <div className="my-7 h-px bg-[rgba(247,244,239,0.1)]" />
            <button
              type="button"
              className="btn-gold w-full"
              data-testid="open-reservation-form-button"
              onClick={onReserve}
            >
              Open the Enquiry Form
            </button>
          </div>
        </Reveal>
      </div>
    </div>
  </Section>
);
